import Dialog, { DialogProps } from "@mui/material/Dialog";

export type { DialogProps };

export default Dialog;
